import { USER } from '../constant/actionTypes';

const getRoleList = (state, action) => {
  switch (action.type) {
    case USER.ROLE.SUCCESS:
      return action.payload;
    case USER.ROLE.ERROR:
      return action.payload;
    default:
      return (typeof state === 'undefined') ? [] : state;
  }
};

export default getRoleList;
